export const buttonSizes = [
	'default',
	'small',
	'link',
	'large',
] as const;

export type ButtonSize = typeof buttonSizes[number];

export type ButtonSizeDefinition = {
	lineHeight: number;
	paddingVertical: number;
	paddingHorizontal: number;
	paddingNoLabel?: number;
	fontSize: number;
	gap: number;
	minSize?: number;
};

const DEFAULT_SIZE = 40;
const SMALL_SIZE = 32;

export const ButtonSizes: {[key in ButtonSize]: ButtonSizeDefinition} = {
	default: {
		minSize: DEFAULT_SIZE,
		lineHeight: 18,
		paddingVertical: 10,
		paddingHorizontal: 16,
		fontSize: 14,
		gap: 6,
	},
	small: {
		minSize: SMALL_SIZE,
		lineHeight: 18,
		paddingVertical: 6,
		paddingHorizontal: 10,
		paddingNoLabel: 6,
		fontSize: 14,
		gap: 6,
	},
	link: {
		lineHeight: 18,
		paddingVertical: 2,
		paddingHorizontal: 6,
		paddingNoLabel: 2,
		fontSize: 14,
		gap: 6,
	},
	large: {
		minSize: DEFAULT_SIZE,
		lineHeight: 18,
		paddingVertical: 10,
		paddingHorizontal: 70,
		fontSize: 14,
		gap: 6,
	},
};
